import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

function OrderFormShippingDetails(props) {
  return (
    <React.Fragment>

      <Grid item sm={12}>
        <Typography variant="overline">Product Shipping Details</Typography>
        <div style={{ borderBottom: '1px dashed black' }}></div>
      </Grid>

      <Grid item sm={4}>
        <TextField required fullWidth multiline size="small" minRows={3}
          label="Ship From Address" onFocus={(evt) => evt.target.select()} value={props.data.ship_from}
          onChange={(evt) => props.onChange('ship_from', evt.target.value)}
        />
        {(props.data.customer_address !== '' && props.data.ffl_address !== '') &&
          <React.Fragment>
            <Button variant="text" size="small" onClick={() => props.onChange('ship_from', props.data.customer_address)}>Load Customer Address</Button>
            <Button variant="text" size="small" onClick={() => props.onChange('ship_from', props.data.ffl_address)}>Load FFL Address</Button>
          </React.Fragment>
        }
      </Grid>
      <Grid item sm={4}>
        <FormControl required fullWidth size="small">
          <InputLabel>Select Distributor</InputLabel>
          <Select value={props.data.distributor_id} label="Select Distributor"
            onChange={(evt) => props.onDistributorChange(+evt.target.value)}>
            <MenuItem key={'dist-opt-0'} value={0}>-- please select --</MenuItem>
            {props.distributors.map((distributor, dex) =>
              <MenuItem key={'dist-opt-' + dex} value={distributor.id}>{distributor.name}</MenuItem>
            )}
          </Select>
        </FormControl>
        <TextField fullWidth size="small" label="RMA Number" style={{ marginTop: 16 }}
          onFocus={(evt) => evt.target.select()} value={props.data.rma_number}
          onChange={(evt) => props.onChange('rma_number', evt.target.value)}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField required fullWidth multiline size="small" minRows={3}
          label="Ship To Address" onFocus={(evt) => evt.target.select()} value={props.data.ship_to}
          onChange={(evt) => props.onChange('ship_to', evt.target.value)}
        />
      </Grid>
      <Grid item sm={12}>
        <TextField fullWidth multiline size="small" minRows={3} label="Return Instructions"
          onFocus={(evt) => evt.target.select()} value={props.data.instructions}
          onChange={(evt) => props.onChange('instructions', evt.target.value)}
        />
      </Grid>

    </React.Fragment>
  );
}

export default OrderFormShippingDetails;
